import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { FaMoneyBill, FaTruckMoving } from "react-icons/fa";
import cn from "classnames";

import { Page } from "ui/components";

import { Schedule } from "services/action";
import { Input, Uploader } from "ui/components";

const Clockin = ({ location }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state?.Form);

  const { report_id } = location?.state;

  const [images, setImages] = React.useState([]);
  const [end_odo, setEndOdo] = React.useState();
  const [receipts, setReceipts] = React.useState([]);

  const $onSubmit = async (e) => {
    let payload = {
      end_odo: end_odo,
      images: images,
      receipts: receipts,
    };

    const req = await Dispatch(Schedule.$tapOut(report_id, payload));
    if (req?.message === "success") {
      History.goBack();
    }
  };

  const $handleChangeReceipts = async (i, k, v) => {
    let newItems = [...receipts];

    newItems[i][k] = v;

    setReceipts(newItems);
  };

  React.useEffect(() => {
    let newReceipts = [
      {
        type: 'e-toll',
        images: null,
        nominal: null
      },
      {
        type: 'parking',
        images: null,
        nominal: null
      },
      {
        type: 'fuel',
        images: null,
        nominal: null
      },
      {
        type: 'lain-lain',
        images: null,
        nominal: null
      },
    ]

    setReceipts(newReceipts);
  }, [])

  return (
    <Page
      title="Clockout"
      backTo={() => History.goBack()}
      action={
        <div>
          <Button
            type="button"
            variant="success"
            className={cn(
              "pe-4 ps-4 rounded w-100",
              StateForm?.loading ? "btn-loading" : ""
            )}
            onClick={$onSubmit}
          >
            Simpan
          </Button>
        </div>
      }
    >
      <div className="px-2 py-3">
        <div className="border-bottom">
          <span className='text-capitalize fw-semibold'>Km Akhir</span>

          <Uploader
            images={images}
            errors={StateForm?.errors?.images}
            onChange={(e) => setImages(e)}
            type="clockout"
            code={report_id}
          />

          {StateForm?.errors?.id ? (
            <div
              className="text-center"
              style={{ marginBottom: 5, marginTop: 10 }}
            >
              <span style={{ color: "red" }}>{StateForm?.errors?.id}</span>
            </div>
          ) : null}

          <div className="form-group ">
            <Input
              icon={<FaTruckMoving />}
              value={end_odo}
              onChange={(e) => {
                setEndOdo(e.target.valueAsNumber);
              }}
              type="number"
              placeholder=""
              error={StateForm?.errors?.end_odo}
              lg
            />
          </div>
        </div>

        {receipts?.map((r, k) => (
          <div key={k} className="border-bottom">
            <span className='text-capitalize fw-semibold'>{r?.type}</span>
            <Uploader
              images={r?.images}
              errors={StateForm?.errors[`receipts.${k}.images`]}
              onChange={(e) =>
                $handleChangeReceipts(k, 'images', e)
              }
              type={`clockout_${r?.type}`}
              code={report_id}
            />

            <div className="form-group ">
              <Input
                icon={<FaMoneyBill />}
                value={r?.nominal}
                onChange={(e) =>
                  $handleChangeReceipts(k, 'nominal', e.target.valueAsNumber)
                }
                type="number"
                placeholder=""
                error={StateForm?.errors[`receipts.${k}.nominal`]}
                lg
              />
            </div>
          </div>
        ))}
      </div>
    </Page>
  );
};

export default Clockin;
